<template>
  <div class="system-header">
    <div class="header-left">
      <!--            <img src="../../assets/imange/system-index/header-logo.png" alt="">-->
      <div class="logo" @click="goHome" :style="{ width: Width }">
        雪亮工程云平台
      </div>
      <el-menu
        :default-active="headActiveIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <template v-for="(item, inx) in menuList">
          <el-menu-item v-if="!item.notShow" :index="item.code" :key="inx">
            <i class="iconfont" :class="['iconfont', item.icon]"></i>
            <p>{{ item.name }}</p>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
    <div class="header-right">
      <div class="bell" style="margin-right: 10px">
        <el-dropdown custom-class="xu-msg" trigger="click">
          <span class="el-dropdown-link" @click="getMsgInfo">
            <div slot="reference" class="user-info-box">
              <i class="el-icon el-icon-bell"></i>
            </div>
          </span>
          <el-dropdown-menu slot="dropdown" >
            <div class="msg-list-box">
              <span class="list-title">消息列表</span>
              <div class="item-list" v-if="msgListInfo.length!=0">
                <div class="list">
                  <el-dropdown-item v-for="(item,index) in msgListInfo" :key="index">
                    <div class="list-item" @click="goDetail(item)">
                      <div v-if="item.status" class="left-icon color-green">
                        <i class="iconfont iconxiaoxi"></i>
                      </div>
                      <div v-else-if="!item.status&&!item.alarm" class="left-icon color-blue">
                        <i class="iconfont iconshipin"></i>
                      </div>
                      <div v-else-if="!item.status&&item.alarm" class="left-icon color-red">
                        <i class="iconfont iconbaojingshanshuo"></i>
                      </div>
                      <div class="right-content">
                        <div class="content">
                          <span class="group-name">{{item.groupName}}</span>
                          <span v-if="!item.status" class="number">{{item.num}}</span>
                        </div>
                        <div class="msg-content">
                          {{item.msgContent}}
                        </div>
                      </div>
                    </div>
                  </el-dropdown-item>
                </div>
              </div>
              <div class="item-list null-info" v-else>
                <span>暂时没有消息</span>
              </div>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-dropdown>
        <span class="el-dropdown-link">
          <div slot="reference" class="user-info-box">
            <span>
              {{
                userName && userName != "null" && userName != null
                  ? userName
                  : phone
                  ? phone
                  : ""
              }}</span
            >
            <i class="el-icon el-icon-caret-bottom"></i>
          </div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="passwd">修改密码</el-dropdown-item>
          <el-dropdown-item @click.native="ownerInfo"
            >个人信息</el-dropdown-item
          >
          <el-dropdown-item @click.native="outLogin">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="修改密码"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="旧密码" prop="oldPwd">
          <el-input type="password" v-model="ruleForm.oldPwd"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input type="password" v-model="ruleForm.newPwd"></el-input>
        </el-form-item>

        <el-form-item label="确认新密码" prop="confirmPad">
          <el-input type="password" v-model="ruleForm.confirmPad"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="dialogVisible1"
      width="800px"
      :before-close="handleClose1"
    >
      <editForm
        ref="ruleForm1"
        :formConfig="formConfig"
        :ruleForm="ruleForm1"
      ></editForm>
    </el-dialog>
  </div>
</template>
<script>
import publicApi from "@/api-path/public-api";

let Base64 = require("js-base64").Base64;
import { loginApi } from "../../api-path/login-api";
import { userApi } from "@/api-path/user-api";
import { listAPI } from "@/api-path/command-center.js";
export default {
  name: "system-header",
  data() {
    return {
      msgListInfo:[],//消息铃铛
      ruleForm: {
        oldPwd: "", //旧密码
        newPwd: "", //新密码
        confirmPad: "", //确认新密码
      },
      ruleForm1: {
        realName: "", //真实姓名，
        areaId: "", //注册区域
        areaName: "", //注册名称
        account: "", //密码
        phone: "", //手机
        idCard: "", //身份证
        remark: "", //备注
        sex: "", //性别
        isTest: true, //用户类型
        portrait: null, //头像，
        portraitList: [],
      },
      dialogVisible: false,
      Width: "",
      userLogo: require("../../assets/images/system-index/user-logo.jpg"),
      userName: localStorage.getItem("p") || "",
      phone: localStorage.getItem("phone") || "",
      siteId: "", //站点ID
      // activeIndex2: "",
      menuList: [],
      rules: {
        oldPwd: [{ required: true, message: "请输入密码", trigger: "change" }],
        newPwd: [
          { required: true, validator: this.padverify, trigger: "change" },
        ],
        confirmPad: [
          { required: true, validator: this.padverify2, trigger: "change" },
        ],
      },
      //个人信息
      title: "个人信息",
      dialogVisible1: false,
      formConfig: {
        disabled: false,
        items: [
          [
            {
              valueType: "upload", // 类型
              label: "头像",
              key: "portraitList", // 数据名称
              prop: "portraitList",
              itemWidth: "100%",
              labelWidth: "100px", // label 宽度
              disabled: false,
              otherConfig: {
                showInfoInput: false,
                imgWidth: "100px",
                imgHeight: "80px",
                method: ["delete", "edit"],
              },
              uploadConfig: {
                accept: "image/jpg,image/jpeg, image/png, image/tif, image/gif",
                uploadPath: publicApi.uploadFile,
                size: "20480kb",
                count: 1,
              },
              options: {
                fileUrlKey: "url",
                fileInfoKey: "description",
              },
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "手机号",
              key: "phone", // 数据名称
              prop: "phone", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: 11,
              disabled: true,
              placeholder: "请输入手机号", // 提示信息
            },
            {
              valueType: "input", // 类型
              label: "用户名",
              key: "account", // 数据名称
              prop: "account", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: 20,
              disabled: true,
              placeholder: "请输入密码", // 提示信息
            },
          ],
          [
            {
              valueType: "tree-selected", // 类型
              label: "注册区域",
              key: "areaName", // 数据名称
              prop: "areaName", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: 50,
              disabled: true,
              placeholder: "请选择注册区域", // 提示信息
              fn: (data) => {
                //选择的值
                this.ruleForm.areaId = data.id;
                this.ruleForm.areaName = data.name;
              },
            },
            {
              valueType: "input", // 类型
              label: "真实姓名",
              disabled: true,
              key: "realName", // 数据名称
              prop: "realName", // 验证规则
              labelWidth: "100px", // label 宽度
              addressLocation: "addressLocation",
              itemWidth: "50%",
              maxlength: "50",
              placeholder: "请输入真实姓名", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "身份证",
              disabled: true,
              key: "idCard", // 数据名称
              prop: "idCard", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: "18",
              placeholder: "请输入身份证", // 提示信息
              fn: (data) => {
                if (
                  data.length == 18 &&
                  parseInt(data.slice(-2, -1)) % 2 == 1
                ) {
                  this.ruleForm.sex = "男";
                } else {
                  this.ruleForm.sex = "女";
                }
              },
            },
            {
              valueType: "input", // 类型
              label: "性别",
              disabled: true,
              key: "sex", // 数据名称
              prop: "sex", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请选择性别", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "备注",
              key: "remark", // 数据名称
              prop: "remark", // 验证规则
              maxlength: 50,
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入备注", // 提示信息
              disabled: true,
            },
          ],
        ],
      },
    };
  },
  computed: {
    alarmId() {
      return this.$store.state.alarmId; //新的报警
    },
    visionGroupId() {
      return this.$store.state.visionGroupId;
    },
    headActiveIndex() {
      return this.$store.state.headActiveIndex;
    },
  },
  watch: {
    alarmId(newVal, oldVal) {
      if (newVal) {
        // this.activeIndex2 = sessionStorage.getItem("active");
        this.$store.commit("SET_HEADACTIVEINDEX", sessionStorage.getItem("active"));
      }
    },
    visionGroupId(newVal, oldVal) {
      if (newVal) {
        // this.activeIndex2 = sessionStorage.getItem("active");
        this.$store.commit("SET_HEADACTIVEINDEX", sessionStorage.getItem("active"));
      }
    },
  },
  created() {
    console.log(this.$store.state.notCompare);
    this.$store.state.configMenuList.forEach((item) => {
      if (item.code == "/GIS" || item.code == "/cloud-picture") {
        item.notShow = true;
      }
    });
    this.menuList = this.$store.state.configMenuList;
    this.Width = document.body.clientWidth * 0.15 + "px";
    // if (sessionStorage.getItem("active")) {
    //   this.activeIndex2 = sessionStorage.getItem("active");
    //   this.$router.push(this.activeIndex2);
    //   sessionStorage.removeItem("active");
    // } else {
    //   let path = this.$route.path.split("/")[1];
    //   this.activeIndex2 = "/" + path;
    //   sessionStorage.setItem("active", this.activeIndex2);
    // }
  },
  methods: {
    //获取消息列表
    getMsgInfo(){
      this.$http.get(loginApi.queryGroupInfo).then(res=>{
        if(res.status==200){
          this.msgListInfo=res.result;
        }
      })
    },
    //跳转页面详情
    goDetail(item){
      this.$http.get(loginApi.setGroupInfoFinish,{ params: { groupId: item.groupId } }).then(res=>{
        if(res.status==200){
          if(item.alarm){//应急联动
            this.goMercy(item.groupId)
          }else{//会议
            this.acceptAlarm2(item.groupId)
          }
        }
      })
    },
    //跳转联动报警
    goMercy(id) {
      this.$http.get(listAPI.datail + "?alarmId=" + id).then((res) => {
        if (res.status == 200) {
          localStorage.setItem("eventUserId", res.result.userId);
          sessionStorage.setItem("groupId", id);
          this.$store.commit("setVisionGroupId", id);
          sessionStorage.setItem("alarmInfo", JSON.stringify(res.result));
          this.$store.commit("setAlarmId", id);
          sessionStorage.setItem("active", "/command");
          let href = window.location.href.split("#")[1];
          if (res.result.report) {
            //是否已上报
            if (href != "/command/up-report") {
              this.$store.commit("setVisionGroupId", id);
              sessionStorage.setItem("active", "/command");
              this.$router.push({ path: "/command/up-report" });
            } else {
              this.$store.commit("setVisionGroupId", id);
            }
          } else if (res.result.join) {
            //已参与
            if (href != "/command/participation") {
              this.$store.commit("setVisionGroupId", id);
              sessionStorage.setItem("active", "/command");
              this.$router.push({ path: "/command/participation" });
            } else {
              this.$store.commit("setVisionGroupId", id);
            }
          } else if (res.result.status == 2) {
            //处理中
            if (href != "/command/map") {
              if (href != "/home") {
                sessionStorage.setItem("active", "/command");
                this.$router.push({
                  path: "/command/map",
                });
              } else {
                // sessionStorage.setItem('active','/command')
                this.$router.replace("/command/map");
              }
            }
          } else if (res.result.status == 6) {
            //分派任务
            if (href != "/command/map") {
              sessionStorage.setItem("active", "/command");
              this.$router.push({
                path: "/command/map",
              });
            }
          }
        } else {
          $this.$store.commit("setHasNewAlarm", true);
        }
      });
    },
    //跳转会议
    acceptAlarm2(id) {
      this.$http
        .get(publicApi.getGroupInfo, { params: { groupId: id } })
        .then((res) => {
          if (res.status == 200) {
            if (res.result.deleted) {
              //结束
              this.$notify({
                title: "会议提示",
                message: "《" + res.result.groupName + "》" + "会议已结束！",
              });
            } else {
              let href = window.location.href.split("#")[1];
              if (href == "/visual-intercom/real-time-intercom") {
                sessionStorage.setItem("active", "/visual-intercom");
                this.$store.commit("setMeetingId", id);
                sessionStorage.setItem("meetingId", id);
              } else {
                sessionStorage.setItem("active", "/visual-intercom");
                this.$store.commit("setMeetingId", id);
                sessionStorage.setItem("meetingId", id);
                this.$router.push({ path: "/visual-intercom/real-time-intercom" });
              }
            }
          }
        });
    },
    goHome() {
      this.$router.push("/home");
    },
    padverify(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        var regu = "^[0-9a-zA-Z]{6,16}$";
        var re = new RegExp(regu);
        if (!re.test(value)) {
          callback(new Error("必须为6-16位字母或数字"));
        } else {
          callback();
        }
      }
    },
    padverify2(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入确定密码"));
      } else {
        if (value == this.ruleForm.newPwd) {
          callback();
        } else {
          callback(new Error("两次输入密码不一致!"));
        }
      }
    },
    handleSelect(index) {
      // sessionStorage.removeItem("defaultMenu");
      const $this = this;
      let path = $this.$route.path.split("/")[1];
      if (index != "/" + path) {
      //   $this.activeIndex2 = index;
      //   sessionStorage.setItem("active", $this.activeIndex2);
        $this.$router.push(index);
      this.$store.commit("SET_HEADACTIVEINDEX", index);

      }
    },
    // 退出登录
    outLogin() {
      this.$http.get(loginApi.logOut).then((res) => {
        if (res.status === 200) {
          this.$store.commit("setIsBreakIM", true);
          window.websock ? window.websock.close() : "";
          this.$store.commit("setAlarmId", "");
          this.$store.commit("clearLoginInfo");
          this.$router.push("/login");
        }
      });
    },
    passwd() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.$refs["ruleForm"].resetFields();
    },

    handleClose1() {
      this.dialogVisible1 = false;
      this.$refs["ruleForm1"].resetFields();
    },

    ownerInfo() {
      this.$http
        .get(userApi.viewUser, {
          params: {
            id: sessionStorage.getItem("userId"),
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.ruleForm1 = {
              realName: res.result.realName, //真实姓名，
              areaId: res.result.areaId, //注册区域
              areaName: res.result.areaName, //注册名称
              account: res.result.account, //
              phone: res.result.phone, //手机
              idCard: res.result.idCard, //身份证
              remark: res.result.remark, //备注
              id: res.result.id, //id
              sex: res.result.sex, //性别
              isTest: res.result.isTest, //用户类型
              portrait: res.result.portrait, //头像
              portraitList: [{ url: res.result.portrait }],
            };
            this.dialogVisible1 = true;
          }
        });
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            newPwd: Base64.encode(this.ruleForm.newPwd),
            oldPwd: Base64.encode(this.ruleForm.oldPwd),
          };
          this.$http.get(loginApi.newPwd, { params: params }).then((res) => {
            if (res.status == 200) {
              this.$message.success("修改密码成功");
              sessionStorage.clear();
              localStorage.clear();
              this.$router.push("/login");
            } else {
              this.$message.error("修改密码失败");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "system-header";
</style>

<style lang="less">
// 消息
.el-dropdown-menu {
  .msg-list-box {
    padding: 0 10px;
      max-height: 600px;
      min-width: 360px;
      overflow-y: scroll;
    .list-title {
      display: flex;
      justify-content: center;
      padding: 0 0 10px 0;
      border-bottom: 1px solid #ececec;
    }
    .item-list {
      .list {
        .el-dropdown-menu__item {
          &:hover {
            background: none;
            color: inherit;
          }
        }
        .list-item {
          width: 300px;
          display: flex;
          align-items: center;
          padding: 10px 0;
          border-bottom: 1px solid #ececec;
          line-height: initial;
          .color-blue{
            background: #0499E7;
            color: #fff;
          }
          .color-red{
            background: #FD6B6B;
            color: #fff;
          }
          .color-green{
            background: #33CC66;
            color: #fff;
          }
          .left-icon {
            width: 35px;
            height: 35px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 10px;
            .iconfont{
              margin-right: 0;
            }
          }
          .right-content {
            flex: 1;
            .content {
              display: flex;
              justify-content: space-between;
              .group-name {
                font-weight: 600;
                font-size: 12px;
              }
              .number {
                width: 25px;
                height: 25px;
                background: #ff3366;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                font-size: 12px;
                transform: scale(0.9);
              }
            }
            .msg-content{
              font-size: 12px;
              color: #888;
            }
          }
        }
      }
    }
    .null-info{
      min-height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #999;
    }
  }
}
.system-header {
  z-index: 10;
  .header-select {
    > .el-select {
      input {
        height: 25px;
      }
    }
  }
  div.el-input,
  div .el-select,
  div .el-date-editor.el-input,
  div .el-textarea {
    width: 100%;
  }
  .header-right {
    align-items: flex-start;
    .el-badge__content {
      background-color: red;
      border: 1px solid red;
    }
  }
  .el-menu-item {
    padding-top: 10px;
    border-bottom: 0 !important;
  }
  .el-menu-item,
  .el-submenu__title {
    line-height: 20px !important;
    text-align: center;
    background: transparent;
  }
  .el-menu {
    background: transparent;
  }
  .el-menu-item [class^="iconfon"] {
    color: #fff;
    font-size: 25px;
    margin-bottom: 5px;
    margin-right: 0 !important;
  }
  .el-menu-item p {
    color: #fff;
    margin-top: 5px;
  }
  .is-active {
    // background: #1f4eb8;
    background: linear-gradient(0deg, rgba(65, 150, 255, 0.75), rgba(0, 57, 184, 0.75));
  }
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
  .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
    // background: #1f4eb8 !important;
    background: linear-gradient(0deg, rgba(65, 150, 255, 0.75), rgba(0, 57, 184, 0.75)) !important;
  }
}
</style>
